<template>
  <div>
    <div class="cont">
      <div class="title">综合管理>人员分析</div>
      <div class="box">
        <div class="box1">
          <div class="box1-t">
            <div class="icon1">
              男女比例
            </div>
            <ccc :title="value"></ccc>
          </div>
          <div class="box1-b">
            <div class="icon1">
              岗位人数
            </div>
            <aaa :title="value3"></aaa>
          </div>
        </div>
        <div class="box2">
          <div class="box2-t">
            <div class="icon1">
              人员分布
            </div>
            <bbb :title="value2"></bbb>
          </div>
          <div class="box2-b">
            <div class="icon1">
              学历统计
            </div>
            <eee :title="value4"></eee>
          </div>
        </div>
        <div class="box3">
          <div class="box3-t">
            <div class="icon1">
              安全教育
            </div>
            <div style="position: absolute; right: 5px;top: 12px;">
              <el-select size="small" v-model="type" style="width: 150px" @change="changeType">
                <el-option label="考试统计" :value="1"></el-option>
                <el-option label="视频观看统计" :value="2"></el-option>
              </el-select>
            </div>
            <!-- <ddd :title="value1"></ddd> -->
            <div id="chart" style="width: 23vw;height: 32vh;"></div>
            <div style="display: flex;justify-content: space-between;padding: 1vh 1vw;">
          <p style="display: flex;align-items: center;">
            <span style="display: inline-block;width: 10px;height: 16px;background-color: #0263FF;border-radius: 3px;margin-right: 5px;"></span>
            <span style="font-size: 0.8vw"><span v-if="type ==1">已通过</span><span v-else-if="type ==2">已观看</span>：{{data.count}}人</span>
          </p>
           <p style="display: flex;align-items: center;">
            <span style="display: inline-block;width: 10px;height: 16px;background-color: #34A1F7;border-radius: 3px;margin-right: 5px;"></span>
            <span style="font-size: 0.8vw"><span v-if="type ==1">未通过</span><span v-else-if="type ==2">未观看</span>：{{data.neverCount}}人</span>
          </p>
        </div>
          </div>
          <div class="box3-b">
            <div class="icon1">
              年龄分布
            </div>
            <fff :title="value5"></fff>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aaa from '../../components/echarts_gangwei.vue'
import bbb from '../../components/echarts_renyuan.vue'
import ccc from "../../components/echarts_nannv.vue";
import ddd from "../../components/echarts_anquan.vue";
import eee from "../../components/echarts_xueli.vue";
import fff from "../../components/echarts_nianling.vue";
import myHttp from '../../untils/port'
import util from '../../untils/util';
export default {
  components:{aaa,bbb,ccc,ddd,eee,fff},
  data() {
    return {
      value: {},
      value1:{},
      value2:{},
      value3:{},
      value4:{},
      value5:{},
      projectId: '',
      type: 1,
      data: {},
      chart: undefined
    }
  },
  mounted(){
    this.projectId = util.session.get('groupId')
    this.chart = this.$echarts.init(document.querySelector('#chart'))
    this.getProportion()
    this.getPerson()
    this.getPersonAddress()
    this.getEductionCount()
    this.getAgeAddress()
    this.getPersonExam()
    // this.getPersonWatch()

    // this.getPersonChartByProject()
  },
  methods:{
    // 获取男女比例
    getProportion(){
      myHttp.getPersonChartByPeople({
        projectId: this.projectId
      }).then(resp => {
        if(resp.data.code === 200){
          this.value = resp.data.data.sex
        }
      })
    },

    // 获取岗位人数
    getPerson(){
      myHttp.getPersonChartByWorkCount({
        projectId: this.projectId
      }).then(resp => {
        if(resp.data.code === 200){
          this.value3 = resp.data.data.post2
        }
      })
    },

    // 获取人员分布
    getPersonAddress(){
      myHttp.getPersonChartByPlace({
        projectId: this.projectId
      }).then(resp => {
        if(resp.data.code === 200){
          this.value2 = resp.data.data.area
        }
      })
    },

    // 获取学历统计
    getEductionCount(){
      myHttp.getPersonChartByEducation({
        projectId: this.projectId
      }).then(resp => {
        if(resp.data.code === 200){
          this.value4 = resp.data.data.education
        }
      })
    },

    // 获取年龄分布
    getAgeAddress(){
      myHttp.getPersonChartByAge({
        projectId: this.projectId
      }).then(resp => {
        if(resp.data.code === 200){
          this.value5 = resp.data.data.age
        }
      })
    },

    // 获取人员考试情况

    // getPersonExam(){
    //   myHttp.getPersonChartByExam({
    //     projectId: this.projectId
    //   }).then(resp => {
    //     // console.log(resp);
    //     if(resp.data.code === 200){
    //       this.data = resp.data.data.exam[0]
    //       this.initChart()
    //     }
    //   })
    // },
        async getPersonExam(){
      const data=await myHttp.personExamCount({
projectId:this.projectId
      })
      if(data.data.code==200){
        this.data=data.data.data
          this.initChart()

      }
    
    },

    // 获取人员视频观看情况
    getPersonWatch(){
      myHttp.getPersonChartByVideoExam({
        projectId: this.projectId
      }).then(resp => {
        // console.log(resp);
        if(resp.data.code === 200){
          this.data = resp.data.data.exam[0]
          this.initChart()
        }
      })
    },

    changeType(type){
      if(type == 1){
        this.getPersonExam()
      }else if(type == 2){
        this.getPersonWatch()
      }
    },


    initChart(){
      this.chart.clear()
      this.chart.setOption({
        title: {
          text: '共计',
          subtext: this.data.sum + '人',
          left: 'center',
          top: 'center',
          textStyle: {
              fontWeight: '900',
              fontSize: '22' 
            },
            subtextStyle: {
              fontWeight: '900',
              fontSize: '22',
              color: '#333'
            }
        },
        series: [
            {
              type: 'pie',
              radius: ["60%", "90%"],
              color: ['#0263FF', '#34A1F7', '#B4D5F1'],
              data: [
                {
                  name: '已通过',
                  value: this.data.count
                },
                {
                  name: '未通过',
                  value: this.data.neverCount
                }
              ],
              label: {
                normal: {
                  show: true,
                  position: 'inner',
                  formatter: '{d}%'
                }
              }
            }
          ]
      })
    }




    // getPersonChartByProject(){
    //   console.log('出发了')
    //   myHttp.getPersonChartByProject({
    //     projectId:util.session.get('groupId')

    //   }).then(res => {
    //     console.log(res);
    //     this.value = res.data.data.sex
    //     this.value1 = res.data.data.exam2
    //     this.value2 = res.data.data.area
    //     this.value3 = res.data.data.post2
    //     this.value4 = res.data.data.education
    //     this.value5 = res.data.data.age
    //     console.log(res.data.data,'77777')
    //   })
    // }
  }
};
</script>

<style scoped>
.cont {
  height: 90.7vh;
  padding-left: 0.417vw;
  padding-right: 1.25vw;
}
.title {
  height: 5.556vh;
  font-family: PingFang-SC-Regular;
  font-size: 1.667vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 5.556vh;
  letter-spacing: 0vh;
  color: #000000;
  text-align: start;
}
.box {
  height: 84vh;
  display: flex;
  justify-content: space-between;
}
.box1 {
  width: 23.438vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box2 {
  width: 38.958vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box3 {
  width: 23.438vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box1-t {
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 41vh;

}
.box1-b {
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 41vh;

}
.box2-t {
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 50vh;

}
.box2-b {
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 32vh;

}
.box3-t {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 41vh;

}
.box3-b {
  background-color: #ffffff;
  box-shadow: 0.176vh 0.213vh 0.926vh 0vh rgba(54, 159, 249, 0.5);
  border-radius: 0.556vh;
  height: 41vh;

}
.icon1{
  width: 7vw;
  height: 4.167vh;
  display: flex;
  align-items: end;
  margin-left: 2.552vw;
  position: relative;
  font-family: PingFang-SC-Bold;
	font-size: 2.222vh;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #333333;
}
.icon1::after{
  content: "";
  width: 0.781vw;
	height: 1.481vh;
	background-color: #0b62f0;
  border-radius: 50px;
  position: absolute;
  left: -1.406vw;top: 2.1vh;
  
}
</style>